// extracted by mini-css-extract-plugin
export default {"inlineTopic":"ArticleCard_inlineTopic__B6Vpr","inlineTitle":"ArticleCard_inlineTitle__S+vAX"};